import React from 'react'
import Card from '../../api/components-examples/ImageCard'
import Group from '../../api/components-examples/ImageCard/Group'
import WaitingLoaders from '../Loaders/WaitingLoaders.jsx'
import { BackNavigation } from '../Back/BackNavigation.js'
import { groupProjects } from '../../api/components-examples/utils/commonUtilityFunctions'

const ProjectsLearn = ({
    openProjectPopup,
    data,
    tabView,
    flowGroups,
    RgroupId,
    fetchAllgroups,
    getIsLocked,
    showAvailable,
    backs,
    checkoutLearnGroup,
    checkoutBuildGroup,
    breadcrumb,
    filteredGroupKeys
}) => {
    const groupsInside = groupProjects(data, RgroupId === null ? 'group_id' : 'DONTGROUP', 'noGroup')

    return (
        <>
            <div className="em-flex" style={{ justifyContent: 'end' }}>
                <BackNavigation
                    backs={() => backs()}
                />
            </div>
            <div className={`sample-projects customScrollDsgn ${tabView ? 'scrollHeight-projects' : ''}`}>
                {fetchAllgroups.isLoading ? (
                    <div className="em-row locenter" style={{ height: '200px' }}>
                        <WaitingLoaders show={true} size={90} position='absolute' />
                    </div>
                ) : (
                    <>
                        {data.length === 0 || (typeof flowGroups === 'object' && !Array.isArray(flowGroups) && filteredGroupKeys.length === 0) ? (
                            <div className="em-column locenter" style={{ height: '100%', padding: '40px', textAlign: 'center' }}>
                                <h3 style={{ color: '#888', fontWeight: '500' }}>No Projects Found</h3>
                                <p style={{ color: '#aaa', fontSize: '14px', maxWidth: '300px' }}>
                                    We couldn't find any projects matching your current plan. Please check back later or contact support.
                                </p>
                            </div>
                        ) : flowGroups && typeof flowGroups === 'object' && !Array.isArray(flowGroups) && (
                            <>
                                {(() => {
                                    let projects = []
                                    if (RgroupId === null) {
                                        filteredGroupKeys.forEach(key => {
                                            if (key === 'default_learn' || key === 'default_build') {
                                                const typeNeeded = key === 'default_learn' ? 'learn' : 'build'
                                                const hasOrphans = (groupsInside['noGroup'] || []).some(card =>
                                                    (!card.group_id || !flowGroups[card.group_id]) &&
                                                    (card.type === typeNeeded || (typeNeeded === 'learn' ? card.learn === true : card.learn === false))
                                                )
                                                if (hasOrphans) {
                                                    projects.push(<Group item={flowGroups[key]} onClick={() => (key === 'default_learn' ? checkoutLearnGroup(key) : checkoutBuildGroup(key))} />)
                                                }
                                            } else if (key !== undefined && key !== null && key !== 'noGroup' && groupsInside[key]) {
                                                projects.push(<Group item={flowGroups[key]} onClick={() => checkoutLearnGroup(key)} />)
                                            }
                                        })
                                    } else {
                                        if (groupsInside['noGroup']) {
                                            groupsInside['noGroup']
                                                .filter(card => {
                                                    if (RgroupId === 'default_learn' || RgroupId === 'default_build') {
                                                        const typeNeeded = RgroupId === 'default_learn' ? 'learn' : 'build'
                                                        return (!card.group_id || !flowGroups[card.group_id]) &&
                                                            (card.type === typeNeeded || (typeNeeded === 'learn' ? card.learn === true : card.learn === false))
                                                    }
                                                    // Named group: only show cards that belong to this group
                                                    return card.group_id === RgroupId
                                                })
                                                .map(card => {
                                                    const isLocked = getIsLocked(card)
                                                    if (showAvailable === true && isLocked === true) return
                                                    projects.push(
                                                        <Card
                                                            item={card}
                                                            onClick={() =>
                                                                openProjectPopup(card.value, card.label, card.flow_id, card.Description, card, false)
                                                            }
                                                            isLocked={isLocked}
                                                        />
                                                    )
                                                })
                                        }
                                    }
                                    return projects.length > 0 ? projects.map(item => item) : (
                                        <div className="em-column locenter" style={{ width: '100%', padding: '40px', textAlign: 'center' }}>
                                            <h3 style={{ color: '#888', fontWeight: '500' }}>No Projects Available</h3>
                                        </div>
                                    )
                                })()}
                            </>
                        )}
                    </>
                )}
            </div>
        </>
    )
}

export default ProjectsLearn
